<template>
    <div class="admin-currency-list">
        <div class="admin-currency-list-item" :data-enabled="currency.enabled">
            <div class="admin-currency-list-item-header" @click="onShowSettinClick">
                <div class="admin-currency-list-tiem-field admin-currency-list-tiem-title">
                    {{currency.asset_name}}
                    <span v-if="!currency.enabled">(Disabled)</span>
                    <el-button
                        icon="el-icon-edit"
                        size="mini"
                        circle
                        @click="onSettingEditClick"
                        v-if="enableAddNewPermission"
                    ></el-button>
                    <el-button
                        icon="el-icon-success"
                        v-if="!currency.enabled"
                        size="mini"
                        circle
                        @click="onEnable"
                        title="Re-enable Currency"
                    ></el-button>
                </div>
                <div class="admin-currency-list-tiem-field admin-currency-list-tiem-desc">
                    <div>{{currency.description}}</div>
                    <div class="updated">Last updated at {{currency.updated | formatDate}}</div>
                </div>
                <div class="admin-currency-list-tiem-detail">
                    <div class="group-title">Exchange Fee</div>
                    <div class="group-contents">
                        <div class="group-content">
                            <div class="title">Fixed</div>
                            <div class="value">{{currency.exchange_fee_fixed||0}}</div>
                        </div>
                        <div class="group-content">
                            <div class="title">percentage</div>
                            <div class="value">{{currency.exchange_fee_percentage||0}}</div>
                        </div>
                    </div>
                </div>
                <div class="admin-currency-list-tiem-detail">
                    <div class="group-title">Exchange Cost</div>
                    <div class="group-contents">
                        <div class="group-content">
                            <div class="title">Fixed</div>
                            <div class="value">{{currency.exchange_cost_fixed||0}}</div>
                        </div>
                        <div class="group-content">
                            <div class="title">percentage</div>
                            <div class="value">{{currency.exchange_cost_percentage||0}}</div>
                        </div>
                    </div>
                </div>
                <div class="admin-currency-list-tiem-detail">
                    <div class="group-title">Transfer Cost</div>
                    <div class="group-contents">
                        <div class="group-content">
                            <div class="title">Fixed</div>
                            <div class="value">{{currency.transfer_cost_fixed||0}}</div>
                        </div>
                        <div class="group-content">
                            <div class="title">percentage</div>
                            <div class="value">{{currency.transfer_cost_percentage||0}}</div>
                        </div>
                    </div>
                </div>
                <div class="admin-currency-list-tiem-detail">
                    <div class="group-title">Withdraw Fee</div>
                    <div class="group-contents">
                        <div class="group-content">
                            <div class="title">Min amount</div>
                            <div class="value">{{currency.min_withdraw_amount||0}}</div>
                        </div>
                        <div class="group-content">
                            <div class="title">Fixed</div>
                            <div class="value">{{currency.withdraw_fee_fixed||0}}</div>
                        </div>
                        <div class="group-content">
                            <div class="title">percentage</div>
                            <div class="value">{{currency.withdraw_fee_percentage||0}}</div>
                        </div>
                    </div>
                </div>
                <div class="admin-currency-list-tiem-detail">
                    <div class="group-title">Withdraw Cost</div>
                    <div class="group-contents">
                        <div class="group-content">
                            <div class="title">Fixed</div>
                            <div class="value">{{currency.withdraw_cost_fixed}}</div>
                        </div>
                        <div class="group-content">
                            <div class="title">percentage</div>
                            <div class="value">{{currency.withdraw_cost_percentage||0}}</div>
                        </div>
                    </div>
                </div>
                <div class="admin-currency-list-tiem-detail">
                    <div class="group-title">Accounts</div>
                    <div class="group-contents">
                        <div class="group-content">
                            <div class="title">Fee account</div>
                            <div
                                class="value" :title="currency.fee_account_display_name||currency.fee_account_email"
                            >{{currency.fee_account_id}} - {{currency.fee_account_display_name||currency.fee_account_email}}</div>
                        </div>
                        <div class="group-content">
                            <div class="title">Cost account</div>
                            <div
                                class="value" :title="currency.cost_account_display_name||currency.cost_account_email"
                            >{{currency.cost_account_id}} - {{currency.cost_account_display_name||currency.cost_account_email}}</div>
                        </div>
                    </div>
                </div>
                <div class="admin-currency-list-tiem-detail" v-if="currency.type == 'TOKEN'">
                    <div class="group-title">CYBAVO</div>
                    <div class="group-contents">
                        <div class="group-content">
                            <div class="title">Deposit</div>
                            <div class="value"
                            >
                                <span v-if="currency.cybavo_deposit_enabled == 1">Enabled</span>
                                <span v-else>Disabled</span>
                            </div>
                        </div>
                        <div class="group-content">
                            <div class="title">Withdraw</div>
                            <div
                                class="value"
                            >
                                <span v-if="currency.cybavo_withdraw_enabled == 1">Enabled</span>
                                <span v-else>Disabled</span></div>
                        </div>
                    </div>
                </div>
                <div class="admin-currency-list-tiem-detail" v-if="currency.asset_name=='AUD'">
                    <div class="group-title">INSTANT PAY</div>
                    <div class="group-contents">
                        <div class="group-content">
                            <div class="title">Deposit</div>
                            <div class="value"
                            >
                                <span v-if="currency.instant_pay_enabled == 1">Enabled</span>
                                <span v-else>Disabled</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-tabs v-model="activeName" class="admin-currency-list-item-setting-list">
                <el-tab-pane label="Permissions" name="permission">
                    <div class="new-btn" @click="onNewClick" v-if="enableAddNewPermission">
                        <i class="el-icon-plus"></i> Add a new permission
                    </div>
                    <el-table
                        :data="tableData"
                        style="width: 100%"
                        stripe
                        v-loading="processing"
                        size="mini"
                        @row-click="onEditClick"
                        row-class-name="permission-list-item"
                    >
                        <el-table-column prop="display_name" label="Name">
                            <template
                                slot-scope="scope"
                            >{{scope.row.display_name || scope.row.email}}</template>
                        </el-table-column>
                        <el-table-column label="Deposit">
                            <el-table-column prop="deposit_booking" label="Booking" width="70">
                                <template slot-scope="scope">
                                    <el-switch :value="scope.row.deposit_booking==1" disabled></el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column prop="deposit_review" label="Review" width="70">
                                <template slot-scope="scope">
                                    <el-switch :value="scope.row.deposit_review==1" disabled></el-switch>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="Withdraw">
                            <el-table-column prop="withdraw_booking" label="Booking" width="70">
                                <template slot-scope="scope">
                                    <el-switch :value="scope.row.withdraw_booking==1" disabled></el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column prop="withdraw_review" label="Review" width="70">
                                <template slot-scope="scope">
                                    <el-switch :value="scope.row.withdraw_review==1" disabled></el-switch>
                                </template>
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                    <div class="load-more" @click="loadMore" v-if="tableData.length<total">more...</div>
                </el-tab-pane>
                <el-tab-pane label="Deposit Info" name="deposit_info">
                    <div class="deposit-info-cards">
                        <el-card class="deposit-info-card new" v-if="enableAddNewDepositInfo">
                            <div slot="header" class="clearfix">
                                <span>Add new deposit info setting</span>
                            </div>
                            <div class="deposit-info-card-content" @click="onNewDepositInfoClick"><i class="el-icon-plus"></i></div>
                        </el-card>
                        <el-card class="deposit-info-card" v-for="item in depositInfos" :key="item.id"  >
                            <div slot="header" class="clearfix" @click="onDepositInfoEditClick(item)">
                                <div>&gt; {{item.min_amount}} {{currency.asset_name}} </div>
                                <div>&lt;= {{item.max_amount}} {{currency.asset_name}}</div>
                            </div>
                            <div class="deposit-info-card-content" v-html="item.description" @click="onDepositInfoEditClick(item)"></div>
                        </el-card>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <AdminCurrencyPermissionNew
            :currency="currency"
            :show="showNew"
            :onClose="onNewClose"
            :permission="selectedData"
        />
        <AdminCurrencySettingEdit
            :currency="currency"
            :show="showEditSetting"
            :onClose="onEditSettingClose"
        />
        <AdminCurrencyDepositInfoNew 
            :currency="currency"
            :show="showDepositInfoNew"
            :onClose="onDepositInfoNewClose"
            :deposit_info="selectedDepositInfoData"
        />
    </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapState } from "vuex";
import AdminCurrencyPermissionNew from "./AdminCurrencyPermissionNew";
import AdminCurrencyDepositInfoNew from "./AdminCurrencyDepositInfoNew";
import AdminCurrencySettingEdit from "./AdminCurrencySettingEdit";

export default {
    name: "AdminCurrencyListItem",
    props: {
        currency: Object,
        selectedId: Number,
        reload: { type: Function, default: () => {} }
    },
    components: {
        AdminCurrencyPermissionNew,
        AdminCurrencySettingEdit,
        AdminCurrencyDepositInfoNew
    },
    data() {
        return {
            activeName: "permission",
            processing: false,
            tableData: [],
            depositInfos: [],
            showSettings: true,
            showNew: false,
            showEditSetting: false,
            showDepositInfoNew: false,
            selectedData: null,
            selectedDepositInfoData: null,
            total: 0,
            skip: 0
        };
    },
    mounted() {
        this.tableData = [];
        this.loadData();
        this.loadDepositInfo();
        // if(this.selectedId == this.currency.id){
        //     this.showSettings = true;
        //     this.loadData();
        // }
    },
    computed: {
        ...mapState({
            adminPerms: state => state.adminPerms
        }),
        enableAddNewPermission() {
            if (this.currency.enabled) {
                if (
                    this.adminPerms &&
                    this.adminPerms.currency &&
                    this.adminPerms.currency.length > 0 &&
                    this.adminPerms.currency[0].visibility
                ) {
                    return true;
                }
            }
            return false;
        },
        enableAddNewDepositInfo() {
            if (this.currency.enabled) {
                if (
                    this.adminPerms &&
                    this.adminPerms.currency &&
                    this.adminPerms.currency.length > 0 &&
                    this.adminPerms.currency[0].add_deposit_info &&
                    this.adminPerms.currency[0].visibility
                ) {
                    return true;
                }
            }
            return false;
        }
    },
    methods: {
        ...mapActions(["request", "setCurrencies", "getError"]),
        loadData() {
            let ctrl = this;
            if(!ctrl.currency.enabled) {
                return;
            }
            // if(!ctrl.adminPerms || !ctrl.adminPerms.currency || ctrl.adminPerms.currency.length == 0 || !ctrl.adminPerms.currency[0].visibility){
            //    return;
            // }
            ctrl.processing = true;
            ctrl.request({
                method: "GET",
                endpoint: `currencies/${this.currency.asset_name}/permissions`,
                params: {
                    where: `email NOT LIKE 'super.%'`
                }
            })
                .then(({ data = {} }) => {
                    ctrl.tableData = data.results;
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "CURRENCY_SETTING_ERROR",
                        message: "Get Currency Permissions Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
        loadMore() {
            this.loadData({ skip: this.skip });
        },

        loadDepositInfo() {
            let ctrl = this;
            if(!ctrl.currency.enabled) {
                return;
            }
            // if(!ctrl.adminPerms || !ctrl.adminPerms.currency || ctrl.adminPerms.currency.length == 0 || !ctrl.adminPerms.currency[0].visibility){
            //    return;
            // }
            ctrl.processing = true;
            ctrl.request({
                method: "GET",
                endpoint: `currencies/${this.currency.asset_name}/deposit_info`,
            })
                .then(({ data = {} }) => {
                    ctrl.depositInfos = data.results;
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "CURRENCY_SETTING_ERROR",
                        message: "Get Currency Deposit Info Settings Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
        onShowSettinClick() {
            if (!this.enableAddNewPermission) {
                return;
            }
            this.showSettings = true;
        },
        onNewClick() {
            if (!this.enableAddNewPermission) {
                return;
            }
            this.showNew = true;
        },
        onNewDepositInfoClick() {
            if (!this.enableAddNewDepositInfo) {
                return;
            }
            this.showDepositInfoNew = true;
        },
        onDepositInfoEditClick(info) {
            if (!this.enableAddNewDepositInfo) {
                return;
            }
            this.selectedDepositInfoData = info;
            this.showDepositInfoNew = true;
        },
        onNewClose(reload = false) {
            this.showNew = false;
            this.selectedData = null;
            if (reload == true) {
                this.tableData = [];
                this.loadData();
            }
        },
        onDepositInfoNewClose(reload = false) {
            this.showDepositInfoNew = false;
            this.selectedDepositInfoData = null;
            if (reload == true) {
                this.loadDepositInfo();
            }
        },
        
        onEditClick(row) {
            if (!this.enableAddNewPermission) {
                return;
            }
            this.selectedData = row;
            this.showNew = true;
        },
        onSettingEditClick() {
            if (!this.enableAddNewPermission) {
                return;
            }
            this.showEditSetting = true;
        },
        onEditSettingClose(reload = false) {
            this.showEditSetting = false;
            if (reload == true) {
                this.tableData = [];
                this.loadData();
                this.reload();
            }
        },
        onEnable() {
            let ctrl = this;
            ctrl.$confirm(
                "Do you wish to re-enable this currency?",
                "Re-enable document",
                {
                    confirmButtonText: `Confirm`,
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            )
                .then(() => {
                    ctrl.processing = true;
                    let method = "POST";
                    let endpoint = `currencies/${ctrl.currency.id}/enable`;
                    ctrl.request({
                        method,
                        endpoint
                    })
                        .then(() => {
                            let message = "Currency has been enabled";
                            ctrl.$message({
                                message,
                                type: "success"
                            });
                            ctrl.reload();
                        })
                        .catch(err => {
                            ctrl.getError({
                                err,
                                title: "CURRENCY_SETTING_ERROR",
                                message: "Enable currency failed"
                            }).then(ctrl.$notify);
                        })
                        .finally(() => {
                            ctrl.processing = false;
                        });
                })
                .catch(() => {});
        }
    }
};
</script>
<style scoped>
.load-more {
    width: 100%;
    line-height: 50px;
    cursor: pointer;
    color: #fff;
    text-align: center;
    border: 1px solid #eee;
    margin-top: 16px;
}
.load-more:hover {
    color: #fff;
    background-color: #00669a;
}

.load-more:active {
    color: #fff;
    background-color: #177CB0;
}
.new-btn {
    width: 100%;
    line-height: 50px;
    cursor: pointer;
    color: #444;
    text-align: center;
    border: 1px solid #eee;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.new-btn:hover {
    color: #fff;
    background-color: #00669a;
}

.new-btn:active {
    color: #fff;
    background-color: #177CB0;
}

.admin-currency-list-item-header {
    color: #fff;
    background-color: #167cb0;
    position: relative;
}

.admin-currency-list-item-setting-list {
    flex: 1;
}

.admin-currency-list-tiem-title {
    padding: 16px 16px 0px;
    line-height: 40px;
    font-size: 26px;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    align-content: center;
    position: relative;
}

.admin-currency-list-tiem-title button {
    position: absolute;
    top: 16px;
    right: 16px;
}

.admin-currency-list-tiem-desc {
    color: #aaa;
    padding: 0px 16px 16px;
    background-color: rgba(0, 0, 0, 0.5);
}

.admin-currency-list-tiem-desc .updated {
    font-size: 12px;
    font-style: italic;
}

.admin-currency-list-item {
    margin-bottom: 16px;
    display: flex;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    border-top: 1px solid rgba(255, 255, 255, 0.3);
}
.admin-currency-list-item[data-enabled="0"] .admin-currency-list-item-header,
.admin-currency-list-item[data-enabled="0"] .admin-currency-list-tiem-desc {
    color: rgba(255, 255, 255, 0.2);
}
.admin-currency-list-tiem-detail {
    display: flex;
    line-height: 30px;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
}

.group-title {
    padding: 8px;
    width: 150px;
    line-height: initial;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
    background-color: rgba(0, 0, 0, 0.3);
}

.group-content .title {
    padding: 0 8px;
    width: 160px;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
    text-align: right;
}

.group-content {
    display: flex;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
    border-right: 1px solid rgba(255, 255, 255, 0.3);
}
.group-content:first-child {
    border-top: none;
}

.group-content:first-child .title {
    border-top: none;
}

.group-content .value {
    padding: 0 8px;
    width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.deposit-info-cards {
    display: flex;
    padding: 8px;
    flex-wrap: wrap;
}

.deposit-info-card {
    width: 250px; 
}

.deposit-info-card {
    margin-bottom: 8px;
    margin-right: 8px;
}
.deposit-info-card-content {
    white-space: normal;
    word-break: break-all;
    cursor: pointer;
}
.new .deposit-info-card-content {
    font-size: 32px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    height: 100%;
}
</style>

<style >
.permission-list-item {
    cursor: pointer;
}

.el-tabs__header {
    background-color: #026395;
    margin-bottom: 0px;
    padding: 0 16px;
}
.el-tabs__item {
    padding: 0 16px;
    color: rgba(255, 255, 255, 0.75);
}
.el-tabs__item.is-active {
    color: #FFF;
}
</style>